/* eslint semi:0 */
import { error, } from './console'
import objectPath from 'object-path'
import { registerInNamespace, } from 'application/nm'
import { create as makeEmptyObj, } from 'utils/object'
import { adsConfig, ADS_QUERYSTRING_OVERRIDE_PREFIXES, } from 'config/adsConfig'
import { queryString, getPossiblyOverriddenPropByQsWithPrefix, } from 'utils/window'


const PAGE_DATA_OBJECT_ID = '_page_data_object'
let pageDataObject = null
const pageDataObjectEl = document.getElementById(PAGE_DATA_OBJECT_ID) // Don't import utils/dom to avoid circular dependencies
const pageDataObjectTextcontent = pageDataObjectEl && pageDataObjectEl.textContent

try {
  pageDataObject = Object.assign(makeEmptyObj(), JSON.parse(pageDataObjectTextcontent))
} catch (ex) {
  error("Can't read or parse pageDataObject:", ex, {
    ex,
    pageDataObjectEl,
    id: PAGE_DATA_OBJECT_ID,
    pageDataObjectTextcontent,
  })
}

const objectPathPdo = objectPath(pageDataObject)
const { get: getFromPdo, } = objectPathPdo
const adsConfPath = getFromPdo('page.ads_conf', {
  dfp_client_id: '175840252', // eslint-disable-line camelcase
})
const shouldShowAds = 'should_show_ads?' in adsConfPath ? adsConfPath['should_show_ads?'] : true // show ads by default!
const { original: adsConfOriginal = {}, } = adsConfPath
const adsConfOriginalPath = {
  clientId: adsConfOriginal.dfp_client_id,
  property: adsConfOriginal.property,
  channel: adsConfOriginal.channel,
  pageType: adsConfOriginal.page_type,
}
const postLayout = getFromPdo('post.layout')
const POST_LAYOUTS = {
  EMBED: 'embed',
  NATIVE: 'native',
  HYBRID: 'hybrid',
  FULL: 'full',
  DRAFT: 'preview',
}

const postTemplate = getFromPdo('post.template')
const POST_TEMPLATES = {
  SLIDESHOW: 'slideshow',
  READER: 'reader',
  PUNDIT: 'pundit',
  TV: 'tv',
  TOPX: 'topx',
}

const excludedComponents = getFromPdo('config.excluded_components', [])

const ENVIRONMENT_NAMES = {
  PROD: 'production',
  DEV: 'development',
}

let postCategoriesSet

let publicPdo = makeEmptyObj({

  get isEmbededPost(){
    return postLayout === POST_LAYOUTS.EMBED
  },

  postTemplate,

  get environment(){
    return getFromPdo('config.env', ENVIRONMENT_NAMES.PROD)
  },

  get isQaEnv(){
    const { DEV, PROD, } = ENVIRONMENT_NAMES
    return ![DEV, PROD, ].includes(publicPdo.environment)
  },

  get isTopX(){
    return postTemplate === POST_TEMPLATES.TOPX
  },

  get isTv(){
    return postTemplate === POST_TEMPLATES.TV
  },

  get isSlideshow(){
    return postTemplate === POST_TEMPLATES.SLIDESHOW
  },

  get isPostReader(){
    return postTemplate === POST_TEMPLATES.READER
  },

  get isPundit(){
    return postTemplate === POST_TEMPLATES.PUNDIT
  },

  get isDraft(){
    return postLayout === POST_LAYOUTS.DRAFT;
  },

  get isNative(){
    return postLayout === POST_LAYOUTS.NATIVE
  },

  get isHybrid(){
    return postLayout === POST_LAYOUTS.HYBRID
  },

  get isFull(){
    return postLayout === POST_LAYOUTS.FULL
  },

  get punditMatchTime(){
    return getFromPdo('pundit.match_date_time')
  },

  get punditBettingProvider(){
    return getFromPdo('pundit.betting_provider_data')
  },

  get canonicalUrl(){
    return getFromPdo('post.url')
  },

  get leaguesForFixtures(){
    return getFromPdo('config.leagues_for_edition.edition_legaues', {})
  },

  get punditData(){
    return {
      homeTeam: getFromPdo('pundit.home_team_name'),
      awayTeam: getFromPdo('pundit.away_team_name'),
      bettingProviderData: getFromPdo('pundit.betting_provider_data'),
      matchTime: getFromPdo('pundit.match_date_time'),
      matchId: getFromPdo('pundit.match_id'),
      punditProfile: getFromPdo('pundit.profile'),
      punditProfileName: getFromPdo('pundit.profile_name'),
      punditPredictionBackground: getFromPdo('pundit.prediction_background'),
      punditPredictionMobileBackground: getFromPdo('pundit.prediction_mobile_background'),
      punditPredictionText: getFromPdo('pundit.prediction_text'),
    }
  },

  get campaigns(){
    return getFromPdo('config.campaigns', {})
  },

  get isPostPage(){
    return getFromPdo('page.type') === 'post'
  },

  get pageType(){
    return getFromPdo('page.type')
  },

  get requestUrl(){
    return getFromPdo('page.requestUrl')
  },

  get pageLocale(){
    return getFromPdo('page.locale')
  },

  get pageDomain(){
    return getFromPdo('post.author.site')
  },

  get reactionsList(){
    return getFromPdo('post.reactions')
  },

  get postCategoriesSet(){
    return postCategoriesSet || (
      postCategoriesSet = (function lazyGetPostCategoriesSet(){
        const { overridePostCategories, } = queryString
        const fakeCategories = overridePostCategories && overridePostCategories.split(',')
        return new Set(fakeCategories || getFromPdo('post.categories', []))
      }())
    )
  },

  get postCategories(){
    return [...this.postCategoriesSet, ]
  },

  get postId(){
    return getFromPdo('post.id', 0)
  },

  isSupportedForDomain(componentName){
    return !excludedComponents.includes(componentName)
  },

  ads: {
    adsConfPath,
    clientId: adsConfPath.dfp_client_id,
    property: adsConfPath.property,
    channel: adsConfPath.channel,
    pageType: adsConfPath.page_type,
    original: adsConfOriginalPath,
    shouldShowAds,
    isProSeven: shouldShowAds && adsConfPath['is_pro7?'] || false,
    getPropWithQsOverride: getPossiblyOverriddenPropByQsWithPrefix.bind(adsConfOriginalPath, ADS_QUERYSTRING_OVERRIDE_PREFIXES),

    get hierarchyLevels(){
      const { getPropWithQsOverride, clientId, property, channel, pageType, } = this
      let staticProps = {
        delimiter: '/',
        l0: getPropWithQsOverride('clientId', clientId),
        l1: getPropWithQsOverride('property', property),
        l2: getPropWithQsOverride('channel', channel),
        l3: getPropWithQsOverride('pageType', pageType),
        format: 'DefaultFormat',
        toString: function adLevelsToString(){
          const { l0, l1, l2, l3, l4, delimiter, } = this
          return [l0, l1, l2, l3, l4, ].join(delimiter)
        },
        get mainLevels(){
          return Object.make(
            {
              toString: function mainLevelsToString(){
                const { property, channel, pageType, } = this // eslint-disable-line no-shadow
                return [property, channel, pageType, ].join(staticProps.delimiter)
              },
            },
            {
              property: this.l1,
              channel: this.l2,
              pageType: this.l3,
            }
          )
        }
      }
      return Object.define(staticProps, {
        set l4(format){
          this.format = format
        },
        get l4(){
          return this.formatWithQsOverride
        },
        get formatWithQsOverride(){
          const { format, } = this
          return getPropWithQsOverride(`format-${ format }`, format)
        },
      })
    },
  },

  get postMediaTypes(){
    return getFromPdo('post.template_data.media_type', [])
  },

  get postMainMediaType(){
    return publicPdo.postMediaTypes[0] || null
  },

  get postBodyMediaTypes(){
    return publicPdo.postMediaTypes.slice(1)
  },

  get isPostMainMediaImage(){
    return (publicPdo.postMainMediaType || '').match(/image/i)
  },

})


publicPdo = Object.assign(publicPdo, objectPathPdo)
if (!publicPdo.has('config.ads')) {
  publicPdo.set('config.ads', adsConfig)
}

// TODO: Render adsConfig on server

registerInNamespace({ pdo: publicPdo, })

export default publicPdo


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/pageDataObject.js